import { injectable } from "@launchtray/tsyringe-async";
import { TriangleViewFactory } from "../triangles/TriangleViewFactory";
import { DeckFigureView } from "./DeckFigureView";
import { IFigureModel } from "../../../models/figure/IFigureModel";
import { SquareViewFactory } from "../square/SquareViewFactory";
import { SquareView } from "../square/SquareView";
import { TriangleView } from "../triangles/TriangleView";
import { BaseFigureView } from "./BaseFigureView";
import { ShadowFigureView } from "./ShadowFigureView";
import { UltimateFigureView } from "./UltimateFigureView";
import { GameUIResourcesPackage } from "../../../../preloader/resources/GameUIResourcesPackage";

@injectable()
export class FigureViewFactory {
    public constructor(
        private readonly triangleViewFactory: TriangleViewFactory,
        private readonly squareViewFactory: SquareViewFactory,
        private readonly gameUIResources: GameUIResourcesPackage
    ) { }

    public createBaseFigureView(figureModel: IFigureModel): BaseFigureView {
        return new BaseFigureView(
            figureModel.FigureData,
            this.getSquareViews(figureModel)
        );
    }

    public createDeckFigureView(figureModel: IFigureModel): DeckFigureView {
        if (figureModel.isUltimate) {
            return new UltimateFigureView(
                figureModel.FigureData,
                this.getSquareViews(figureModel),
                this.gameUIResources
            );
        }
        else {
            return new DeckFigureView(
                figureModel.FigureData,
                this.getSquareViews(figureModel)
            );
        }
    }

    public createShadowFigure(figureModel: IFigureModel): BaseFigureView {
        return new ShadowFigureView(
            figureModel.FigureData,
            this.getSquareViews(figureModel)
        );
    }

    private getSquareViews(figureModel: IFigureModel): Array<SquareView> {
        const squareViews = Array<SquareView>();
        const triangleViews = Array<TriangleView>();
        if (Array.isArray(figureModel.Shape)) {
            for (const square of figureModel.Shape) {
                for (const triangle of square.Triangles) {
                    triangleViews.push(
                        this.triangleViewFactory.createTriangleView(triangle.TriangleRotationStatus, triangle.Color)
                    )
                }
                squareViews.push(this.squareViewFactory.createSquareView(triangleViews));
                triangleViews.length = 0;
            }
        } else {
            for (const triangle of figureModel.Shape.Triangles) {
                triangleViews.push(
                    this.triangleViewFactory.createTriangleView(triangle.TriangleRotationStatus, triangle.Color)
                )
            }
            squareViews.push(this.squareViewFactory.createSquareView(triangleViews));
            triangleViews.length = 0;
        }
        return squareViews;
    }
}